<div fxLayoutAlign="center center" fxLayout="column" fxFlexFill>
  <div fxLayout="column" fxLayoutGap="25px" class="wrapper" fxFlex>

    <form [formGroup]="formGroup">
      <div fxFlex fxLayout fxLayoutGap="15px">
    
        <div fxFlex class="padding-5">
          <mat-card fxLayout="column">
            <div fxLayoutAlign="space-between center">
              <mat-card-title>
                {{ 'LABEL_DETAILS' | translate }}
              </mat-card-title>

              <div>
                <!-- <button mat-icon-button [matTooltip]="!hideDetails ? ('LABEL_HIDE' | translate: {type: 'LABEL_DETAILS' | translate}) : ('LABEL_SHOW' | translate: {type: 'LABEL_DETAILS' | translate})" (click)="hideDetails = !hideDetails">
                  <mat-icon svgIcon="chevron-up" *ngIf="!hideDetails"></mat-icon>
                  <mat-icon svgIcon="chevron-down" *ngIf="hideDetails"></mat-icon>
                </button> -->

                <button [class.filter-color]="filterNumber > 0" mat-icon-button [matTooltip]="'LABEL_FILTER' | translate" (click)="openFilter()">
                  <mat-icon svgIcon="filter-variant"></mat-icon>
                </button>

                <button 
                  mat-icon-button 
                  (click)="download()"
                  [disabled]="!listData?.length"
                  [matTooltip]="'LABEL_DOWNLOAD_TEMPLATE' | translate" 
                  *ngIf="authService.hasPermission(moduleCode + constants.PERMISSION_STRINGS.download)"
                  >
                  <mat-icon svgIcon="download"></mat-icon>
                </button>
              </div>
            </div>

            <div fxLayout fxLayoutGap="25px" *ngIf="!hideDetails">
              <div fxFlex fxLayout="column">
                <div fxLayoutAlign="start center">
                  <span fxFlex="30">
                    {{'LABEL_CAMPAIGN_CODE' | translate}}
                  </span>
    
                  <!-- campaign_code -->
                  <mat-form-field class="width-60">        
                    <input 
                      #campaign_code 
                      matInput
                      required
                      autocomplete="off" 
                      formControlName="campaign_code" 
                      >
                  </mat-form-field>
                </div>

                <div fxLayoutAlign="start center">
                  <span fxFlex="30">
                    {{'LABEL_DISTRIBUTION_CODE' | translate}}
                  </span>
    
                  <!-- distribution_code -->
                  <mat-form-field>        
                    <input 
                      #distribution_code 
                      matInput
                      required
                      autocomplete="off" 
                      formControlName="distribution_code" 
                      >
                  </mat-form-field>
                </div>

                <div fxLayoutAlign="start center" *ngIf="allocationLevel == 'one'">
                  <span fxFlex="30">
                    {{'LABEL_FROM_SERIES' | translate}}
                  </span>
    
                  <!-- from_series -->
                  <mat-form-field>        
                    <input 
                      #from_series 
                      matInput
                      required
                      autocomplete="off" 
                      formControlName="from_series" 
                      >
                  </mat-form-field>
                </div>

                <div fxLayoutAlign="start center" *ngIf="allocationLevel == 'one'">
                  <span fxFlex="30">
                    {{'LABEL_TO_SERIES' | translate}}
                  </span>
    
                  <!-- to_series -->
                  <mat-form-field>        
                    <input 
                      #to_series 
                      matInput
                      required
                      autocomplete="off" 
                      formControlName="to_series" 
                      >
                  </mat-form-field>
                </div>

                <div fxLayoutAlign="start center" *ngIf="allocationLevel == 'two'">
                  <span fxFlex="30">
                    {{'LABEL_SERIES' | translate}}
                  </span>
    
                  <!-- series -->
                  <mat-form-field class="word-wrap">        
                    <textarea
                      #series 
                      matInput
                      readonly="true"
                      autocomplete="off" 
                      formControlName="series" 
                      cdkTextareaAutosize
                      #autosize="cdkTextareaAutosize"
                      >
                    </textarea>
                  </mat-form-field>
                </div>
              </div>

              <div fxFlex fxLayout="column">
                <div fxLayoutAlign="start center">
                  <span fxFlex="30">
                    {{'LABEL_CAMPAIGN_NAME' | translate}}
                  </span>
    
                  <!-- campaign_description -->
                  <mat-form-field> 
                    <input 
                      #campaign_description 
                      matInput
                      required
                      autocomplete="off" 
                      formControlName="campaign_description" 
                      >
                  </mat-form-field>
                </div>

                <div fxLayoutAlign="start center">
                  <span fxFlex="30">
                    {{'LABEL_DISTRIBUTION_NAME' | translate}}
                  </span>
    
                  <!-- distribution_description -->
                  <mat-form-field> 
                    <input 
                      #distribution_description 
                      matInput
                      required
                      autocomplete="off" 
                      formControlName="distribution_description" 
                      >
                  </mat-form-field>
                </div>

                <div fxLayoutAlign="start center">
                  <span fxFlex="30">
                    {{'LABEL_TOTAL_QTY' | translate}}
                  </span>
    
                  <!-- total_quantity -->
                  <mat-form-field> 
                    <input 
                      #total_quantity 
                      matInput
                      required
                      autocomplete="off" 
                      formControlName="total_quantity" 
                      >
                  </mat-form-field>
                </div>
        
                <div fxLayoutAlign="start center">
                  <span fxFlex="30">
                    {{'LABEL_AVAIL_QTY' | translate}}
                  </span>
    
                  <!-- available_quantity -->
                  <mat-form-field>        
                    <input 
                      #available_quantity 
                      matInput
                      required
                      autocomplete="off" 
                      formControlName="available_quantity" 
                      >  
                  </mat-form-field>
                </div>
        
                <div fxLayoutAlign="start center">
                  <span fxFlex="30">
                    {{'LABEL_ALLOCATED_QTY' | translate}}
                  </span>
    
                  <!-- allocated_qty -->
                  <mat-form-field>        
                    <input 
                      #allocated_qty 
                      matInput
                      required
                      autocomplete="off" 
                      formControlName="allocated_qty" 
                      >  
                  </mat-form-field>
                </div>
              </div>
            </div>

          </mat-card>
        </div>
      </div>
    </form>

    <div fxFlex fxLayout fxLayoutGap="15px">
      <div fxFlex class="padding-5">
        <mat-card fxLayout="column" class="height-100">
          <mat-card-title>
            {{ 'LABEL_COUPON_ALLOC' | translate }}
          </mat-card-title>
 
          <div fxLayout="column" *ngIf="!loading.init && listData?.length" [class.empty-report]="!listData?.length" fxFlex>
            <div>
              <table mat-table [dataSource]="listData">
                <!-- username -->
                <ng-container matColumnDef="username">
                  <th mat-header-cell *matHeaderCellDef>{{'TBL_HDR_WEB_USER' | translate}}</th>
                  <td mat-cell *matCellDef="let element"> 
                    {{element?.username}} - {{element?.fullname}}
                  </td>
                </ng-container>

                <!-- fullname -->
                <ng-container matColumnDef="fullname">
                  <th mat-header-cell *matHeaderCellDef>{{'TBL_HDR_RECIPIENT' | translate}}</th>
                  <td mat-cell *matCellDef="let element"> 
                    {{element?.reference_code}} - {{element?.fullname}}
                  </td>
                </ng-container>

                <!-- group_filter -->
                <ng-container matColumnDef="group_filter">
                  <th mat-header-cell *matHeaderCellDef>{{'TBL_HDR_GROUP' | translate}}</th>
                  <td mat-cell *matCellDef="let element"> 
                    <span [matTooltip]="element?.group_filter?.code + ' - ' + element?.group_filter?.description" matTooltipPosition="right">
                      {{element?.group_filter?.description}}
                    </span>
                  </td>
                </ng-container>
          
                <!-- quantity -->
                <ng-container matColumnDef="quantity">
                  <th mat-header-cell *matHeaderCellDef>{{'TBL_HDR_QUANTITY' | translate}}</th>
                  <td mat-cell *matCellDef="let element; let i = index">
                    <mat-form-field class="width-100-impt">
                      <input
                        #quantity
                        matInput
                        autocomplete="off"
                        [(ngModel)]="quantity[i]"
                        (ngModelChange)="quantityChanged(element, quantity[i], i)"
                        >

                      <div class="pseudo-error-wrapper" *ngIf="helper.validateNumberPattern(quantity[i])">
                        <div class="pseudo-error">
                          {{ 'MSG_NUMBERS_ONLY' | translate }}
                        </div>
                      </div> 

                      <div class="pseudo-error-wrapper" *ngIf="helper.validateMinQty(quantity[i])">
                        <div class="pseudo-error">
                          {{ 'MSG_MIN' | translate: {quantity: 1} }}
                        </div>
                      </div> 
                    </mat-form-field>
                  </td>
                </ng-container>
          
                <!-- allocated_quantity -->
                <ng-container matColumnDef="allocated_quantity">
                  <th mat-header-cell *matHeaderCellDef [innerHtml]="'TBL_HDR_ALLOCATED_QTY' | translate"></th>
                  <td mat-cell *matCellDef="let element"> 
                    {{element?.allocated_quantity}}
                  </td>
                </ng-container>    
          
                <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
              </table>
            </div>
          
          </div>
        </mat-card>
      </div>
    </div>
  </div>
      
  <div fxLayout fxLayoutAlign="center center" fxLayoutGap="15px" *ngIf="listData.length">
    <button color="primary" mat-raised-button (click)="validateInputQuantity()" [disabled]="disableAllocation()">
      {{ 'LABEL_ALLOCATE' | translate }}
    </button>
  </div>
</div>